import React, { useState, useEffect, Component, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { salvarEmExcel } from '~/Utils/Helpers';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import { Row, Col, Media, Container } from 'react-bootstrap';
import Loading from '~/Components/Loading';
import PDFThumb from '~/Utils/PDFThumb';
import { FaDownload } from 'react-icons/fa';

const Contratos = () => {
  const grupoEmpresaAtual = useSelector(
    state => state.prospecto.detail.codigo_grupo_empresa
  );
  const codigoContaAtual = useSelector(
    state => state.prospecto.detail.codigo_conta
  );
  const [carregando, setCarregando] = useState(false);
  const [contratos, setContratos] = useState([]);

  const obterContratosProspecto = async () => {
    try {
      setCarregando(true);
      const response = await api.buscarContratosProspecto(
        codigoContaAtual,
        grupoEmpresaAtual
      );
      if (response) {
        for (let i = 0; i < response.length; i++) {
          const thumb = await PDFThumb.create(response[i].link_pdf.url);
          response[i].imagem = thumb;
        }
      }
      setContratos(response);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCarregando(false);
    }
  };

  const abrirLinkPDF = url => {
    window.open(url, '_blank');
  };

  useEffect(() => {
    obterContratosProspecto();
  }, []);

  return (
    <div>
      {!carregando &&
        contratos.length > 0 &&
        contratos.map((contrato, index) => (
          <div className="mt-2">
            <small>{contrato.link_pdf.nome}</small>
            <Row className="mt-2">
              <Col xs="12" sm="6" md="4" key={index}>
                <Fragment>
                  <ul className="list-unstyled">
                    <Media
                      as="li"
                      className={'align-items-center mb-2'}
                      style={{
                        background: '#f8f9fa',
                        borderRadius: '0.7rem',
                        padding: '10px',
                      }}
                    >
                      <Fragment>
                        <div
                          style={{
                            backgroundImage: `url(${contrato.imagem})`,
                            width: '50px',
                            height: '50px',
                            backgroundSize: 'cover',
                            backgroundPosition: '50%',
                            backgroundColor: '#ebebeb',
                            overflow: 'hidden',
                            border: '1px solid #ddd',
                            cursor: 'pointer',
                          }}
                          className="img align-self-center mr-3"
                          onClick={() => {
                            abrirLinkPDF(contrato.link_pdf.url);
                          }}
                          title="Abrir PDF"
                        />
                        <Media.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div
                              onClick={() => {
                                abrirLinkPDF(contrato.link_pdf.url);
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <small>Visualizar contrato.</small>
                            </div>
                            <FaDownload
                              title="Download do contrato"
                              onClick={() => {
                                salvarEmExcel(
                                  contrato,
                                  '/exportador/contrato/download'
                                );
                              }}
                              style={{
                                cursor: 'pointer',
                                border: '2px black',
                              }}
                              size={20}
                            />
                          </div>
                        </Media.Body>
                      </Fragment>
                    </Media>
                  </ul>
                </Fragment>
              </Col>
            </Row>
          </div>
        ))}
      {!carregando && contratos.length === 0 && (
        <div className="text-center">
          <label>Nenhum contrato encontrado.</label>
        </div>
      )}
      {carregando && (
        <div>
          <Loading />
        </div>
      )}
    </div>
  );
};

export default Contratos;
